export default [
  {
    title: "ITP",
  },
  {
    title: "Vulcanizare",
  },
  {
    title: "Climatizare",
  },
  {
    title: "General",
  },
  {
    title: "Service",
  },
]
